import { render, staticRenderFns } from "./facebookemail.vue?vue&type=template&id=1dbe5460&scoped=true&"
import script from "./facebookemail.vue?vue&type=script&lang=js&"
export * from "./facebookemail.vue?vue&type=script&lang=js&"
import style0 from "./facebookemail.vue?vue&type=style&index=0&id=1dbe5460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbe5460",
  null
  
)

export default component.exports